<div class="container">
    <h2 mat-dialog-title>Review Termination</h2>

    <div mat-dialog-content class="dialog-content">
        <div class="termination-details">
            <div class="detail-row">
                <span class="label">Merchant ID:</span>
                <span class="value">{{ data.terminationRecord.merchantId }}</span>
            </div>
            <div class="detail-row">
                <span class="label">Created By:</span>
                <span class="value">{{ data.terminationRecord.createdByDisplay }}</span>
            </div>
            <div class="detail-row">
                <span class="label">Created At:</span>
                <span class="value">{{ data.terminationRecord.createdAt | date }}</span>
            </div>
        </div>
    </div>

    <div class="form-actions" mat-dialog-actions>
        <button mat-flat-button color="primary" [disabled]="isSubmitting || data.terminationRecord.status !== 'PENDING'"
            (click)="approve()">
            Approve & Send
        </button>
        <button mat-flat-button color="warn" [disabled]="isSubmitting || data.terminationRecord.status !== 'PENDING'"
            (click)="reject()">
            Reject
        </button>
        <button mat-flat-button class="cancel" (click)="cancel()">
            Cancel
        </button>
    </div>
</div>